import React, { FC } from 'react'
import 'styled-components'
import styled from 'styled-components'

import ItemGroup from './ItemGroup'
import { BaseItem } from './BaseItem'
import { DropdownMenuItem } from './types'
import { ItemRedirect } from './ItemRedirect'
import { buttonCss, StyledLink } from './Item.styles'

type Props = {
  item: DropdownMenuItem
  leaveSpaceForSubmenu: boolean
  onContextMenuClick?: () => void
}

const Item: FC<Props> = ({ item, leaveSpaceForSubmenu, onContextMenuClick }) => {
  if (item.type === 'itemGroup') {
    return <ItemGroup item={item} leaveSpaceForSubmenu={leaveSpaceForSubmenu} />
  }

  if (item.type === 'text') {
    return (
      <BaseItem
        item={item}
        leaveSpaceForSubmenu={leaveSpaceForSubmenu}
        onContextMenuClick={onContextMenuClick}
      />
    )
  }

  if (item.type === 'link') {
    return (
      <StyledLink to={item.linkTo}>
        <BaseItem item={item} leaveSpaceForSubmenu={leaveSpaceForSubmenu} />
      </StyledLink>
    )
  }

  if (item.type === 'redirect') {
    return <ItemRedirect item={item} leaveSpaceForSubmenu={leaveSpaceForSubmenu} />
  }

  if (item.type === 'button') {
    return (
      <DropdownMenuButton
        item={item}
        renderAs="button"
        leaveSpaceForSubmenu={leaveSpaceForSubmenu}
      />
    )
  }

  throw new Error('Your item type is bad and you should feel bad')
}

const getItemKey = (i: DropdownMenuItem) => `${i.type}-${i.label}-${i.description}-${i.icon}`
export const renderItem = (
  item: DropdownMenuItem,
  leaveSpaceForSubmenu: boolean,
  onContextMenuClick?: () => void
) => (
  <Item
    key={getItemKey(item)}
    item={item}
    leaveSpaceForSubmenu={leaveSpaceForSubmenu}
    onContextMenuClick={onContextMenuClick}
  />
)

export default Item

// Workaround - DropdownMenuButton nemuze byt definovan ve styles.ts, protoze kdyz
// tam importuju BaseItem, tak to dela circular dependency fuckup.
const DropdownMenuButton = styled(BaseItem)`
  ${buttonCss}
`
